<template>
  <i
    :class="{
      'block h-[3px] w-[9px] bg-www-color-accent-orange': true,
    }"
  />
</template>

<script lang="ts" setup></script>
